
import {
  Box,
  Button,
  Stack,
  Typography
} from '@mui/material';
import _ from 'lodash';
import {
  filterInstallationsVar,
  IFilterInstallationsVar
} from 'modules/common/layer00/reactiveVariables';
import React from 'react';
import {
  useLocation,
  useNavigate,
  useParams
} from 'react-router-dom';

import { theme } from 'theme';

export type InstallationMetricType =
'completedFinish' |
'overdueFinish' |
'upcomingFinish' |
'remainingSelections';

const __type2InstallationMetricColor: Record<InstallationMetricType, string> = {
  completedFinish: theme.palette.primary.main,
  overdueFinish: theme.palette.error.main,
  upcomingFinish: theme.palette.warning.main,
  remainingSelections: theme.palette.info.main
};

const __type2FilterProperty: Record<InstallationMetricType, keyof IFilterInstallationsVar> = {
  completedFinish: 'isComplete',
  overdueFinish: 'isOverDue',
  upcomingFinish: 'isUpcoming',
  remainingSelections: 'isRemaining'
};


export type ProjectInstallationMetricProps = {
  metricType: InstallationMetricType;
  count: number;
  title: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ProjectInstallationMetricProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  return (
    <Box
      display='flex'
      flexDirection='column'
      width='7.75rem'
      marginLeft={props.metricType !== 'completedFinish' ? '-1rem' : '0rem'}
      height='7.75rem'
      flex={
        props.metricType !== 'remainingSelections'
          ? '1 1 0'
          : '4 1 0'
      }
      borderRadius='.5rem'
      bgcolor={__type2InstallationMetricColor[props.metricType]}
      justifyContent='center'
      alignItems='center'
      textAlign='center'
    >

      <Stack
        direction='column'
        textAlign='center'
        width='100%'
        flex='1 1 0'
        rowGap='.5rem'
        borderRadius='.5rem 0rem 0rem 0rem'
        justifyContent='center'
        bgcolor={props.metricType === 'remainingSelections' ? theme.palette.info.light : 'transparent'}
      >
        <Typography
          color={props.metricType === 'remainingSelections' ? theme.palette.info.main : 'white'}
          variant='summaryMetricValue'
        >
          {props.count}
        </Typography>
        <Typography
          variant='summaryMetricName'
          color={props.metricType === 'remainingSelections' ? theme.palette.info.main : 'white'}
        >
          {props.title}
        </Typography>
      </Stack>
      <Button
        variant='text'
        onClick={() => {
          const filter = filterInstallationsVar();
          filterInstallationsVar({
            ..._.mapValues(filter, (node, key) => {
              if (key === __type2FilterProperty[props.metricType]) {
                return true;
              }
              return false;
            }),
            roomName: filter.roomName,
            freeTextSearch: filter.freeTextSearch,
            areaId: filter.areaId,
            installationTypeId: filter.installationTypeId,
            milestoneId: filter.milestoneId
          });

          // handle routing if not on the right route
          if (!location.pathname.endsWith('installations')) {
            // navigate to the installations route
            navigate(`/organization/projects/${params.projectId}/installations`);
          }
        }}
        sx={{
          color: 'white'
        }}
      >
        View
      </Button>
    </Box>
  );
};
